module.exports = __webpack_public_path__ + "static/PastoralCare2-3393182eb284f6bc28d602e0fb80f017.jpg";